import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {

    transform(values: any[], searchText: any): any[] {
        if (!values) return [];
        if (!searchText || searchText instanceof Object) return values;

        return values.filter(value => {
            return Object.keys(value).some(key => {
                return String(value[key]).toLowerCase().includes(searchText.toLowerCase())
            })
        })
    }

}
